import { createI18n } from "vue-i18n"

const i18n = createI18n({ locale: "fr", legacy: false, warnHtmlMessage: false })

export default i18n
